export class StorageStorage {
  id: number;
  code: string;
  name: string;
  companyId: number;
  companyName: string;
  ownerId: number;
  ownerName: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/StorageStorage.ts